<template>
  <vbt-error-boundary
    :error="$attrs.error"
    :no-content="!items.length"
  >
    <vbt-table
      :headers="headers"
      :items="items"
      show-paginator
    >
      <template #orderItemId="{ item: { orderItemId } }">
        {{ orderItemId || '-' }}
      </template>
      <template #inputMessageId="{ item: { inputMessageId } }">
        <router-link
          v-if="inputMessageId"
          :class="$_themeTextColorClass"
          :to="{
          name: 'inputMessage',
          params: { id: inputMessageId },
          query: { suffix },
        }"
        >
          {{ inputMessageId }}
        </router-link>
        <span v-else>
        -
      </span>
      </template>
      <template #processed="{ item: { processed } }">
        {{ formatDate(processed, { dateFormat: 'yyyy-MM-dd, hh:mm:ss.SSS a' }) }}
      </template>
    </vbt-table>
  </vbt-error-boundary>
</template>

<script>
import { mapState } from 'vuex';

import { provideThemeSettings } from '@mixins';

import { formatDate } from '@helpers';

import { namespace as LocationsNamespace } from '@store/modules/locations.types';

const headers = Object.freeze([
  { text: 'Order Item ID', value: 'orderItemId' },
  { text: 'Input Message ID', value: 'inputMessageId' },
  { text: 'Operator', value: 'operator' },
  { text: 'Processed Date', value: 'processed' },
  { text: 'Description', value: 'description' },
]);

export default {
  name: 'KernelOrderHistoryList',
  mixins: [
    provideThemeSettings,
  ],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({ headers }),
  computed: {
    ...mapState(LocationsNamespace, ['suffix']),
  },
  methods: {
    formatDate,
  },
};
</script>
